import React, { FC } from 'react'

import FormikField from '../../FormikField'
import { FormFieldToggleButtonProps } from '../FormFieldToggleButton'
import { FormLabelProps } from '../../FormLabel'

import * as SC from './styled'

export type FormFieldToggleButtonGroupProps = {
  className?: string
  label?: string
  name: string
  options: Array<Omit<FormFieldToggleButtonProps, 'name'>>
  required?: boolean
  disabled?: boolean
  error?: string
  help?: string
  hasError?: boolean
  labelVariant?: FormLabelProps['variant']
  allowMultiple?: boolean
}

const FormFieldToggleButtonGroup: FC<FormFieldToggleButtonGroupProps> = ({
  className,
  disabled,
  required,
  name,
  help,
  hasError,
  options,
  label,
  error,
  labelVariant,
  allowMultiple = true,
}) => {
  return (
    <SC.Wrapper className={className} $isDisabled={disabled}>
      {label && (
        <SC.Label required={required} error={!!error || hasError} variant={labelVariant}>
          {label}
        </SC.Label>
      )}
      <SC.Options>
        {options.map((option) => (
          <FormikField
            {...option}
            key={`toggle-option-${option.value}`}
            name={name}
            type={allowMultiple ? 'checkbox' : 'radio'}
            Component={SC.Checkbox}
            showError={false}
            isGroupChild
            disabled={disabled || option.disabled}
          />
        ))}
      </SC.Options>
      {!error && help && <SC.Help>{help}</SC.Help>}
      {error && <SC.Error>{error}</SC.Error>}
    </SC.Wrapper>
  )
}

export default FormFieldToggleButtonGroup
